import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const InformationColumn = styled(Box)`
  gap: 2px;
`
